import { Card, CardContent, makeStyles } from "@material-ui/core";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";
import { Doughnut } from "react-chartjs-2";

ChartJS.register(ArcElement, Tooltip, Legend);

const useStyles = makeStyles((theme) => ({
  card: {
    width: "100%",
  },
  cardcontent: {
    height: "2.7rem!important",
  },
}));

function DoughnutChart_R({ data }) {
  const classes = useStyles();

  let options = {
    borderWidth: 2,
    responsive: true,
    plugins: {
      legend: {
        display: "true",
        position: "bottom",
        onClick: (e) => e.stopPropagation(),
      },
    },
  };

  return (
    <Card className={classes.card}>
      <CardContent className={classes.cardcontent}></CardContent>
      <CardContent>
        {data?.length !== 0 ? <Doughnut data={data} options={options} /> : ""}
      </CardContent>
    </Card>
  );
}

export default DoughnutChart_R;
